import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber, defineMessages } from 'react-intl';
import { LocalizableMessage, LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';
export var activityFilterDefaultLabel = React.createElement(FormattedMessage, {
  id: "filter.activities",
  defaultMessage: "Activities"
});
export var amenityFilterDefaultLabel = React.createElement(FormattedMessage, {
  id: "filter.amenities",
  defaultMessage: "Amenities"
});
export var levelFilterDefaultLabel = React.createElement(FormattedMessage, {
  id: "filter.levels",
  defaultMessage: "Levels"
});
export var radiusDefaultLabel = React.createElement(FormattedMessage, {
  id: "filter.radius.distance",
  defaultMessage: "Distance"
});
export var creditsLabels = defineMessages({
  default: {
    id: 'filter.credits.default',
    defaultMessage: 'Credits'
  },
  singleAmount: {
    id: 'filter.credits.value',
    defaultMessage: '{numCredits} credits'
  },
  maxCredits: {
    id: 'filter.credits.valueMax',
    defaultMessage: '{numCredits}+ credits'
  },
  rangeWithMax: {
    id: 'filter.credits.valueRangeWithMax',
    defaultMessage: '{low} - {high}+ credits'
  },
  range: {
    id: 'filter.credits.valueRange',
    defaultMessage: '{low} - {high} credits'
  }
});
export var moreFiltersLabel = React.createElement(FormattedMessage, {
  id: "filter.more",
  defaultMessage: "More"
});
export var MultiSelectCountLabel = function MultiSelectCountLabel(_ref) {
  var firstSelectedItem = _ref.firstSelectedItem,
      count = _ref.count;
  return React.createElement(FormattedMessage, {
    id: "filter.multiselect.count",
    defaultMessage: "{firstSelectedItem} +{count}",
    values: {
      count: React.createElement(FormattedNumber, {
        value: count
      }),
      firstSelectedItem: React.createElement(LocalizableMessage, {
        message: firstSelectedItem
      })
    }
  });
};
MultiSelectCountLabel.propTypes = {
  firstSelectedItem: LocalizableMessageShape.isRequired,
  count: PropTypes.number.isRequired
};
export var radiusMessages = defineMessages({
  imperial: {
    id: 'filters.radius.imperial',
    defaultMessage: '{radius} {radius, plural, one {mile} other {miles}}'
  },
  half_mile: {
    id: 'filters.radius.half-mile',
    defaultMessage: '1/2 mile'
  },
  metric: {
    id: 'filters.radius.metric',
    defaultMessage: '{radius} km'
  },
  auto: {
    id: 'filters.radius.auto',
    defaultMessage: 'Auto'
  }
});
export var amenityMessages = defineMessages({
  showers: {
    id: 'filters.amenity.shower.name',
    defaultMessage: 'Showers'
  },
  lockers: {
    id: 'filters.amenity.locker.name',
    defaultMessage: 'Lockers'
  },
  parking: {
    id: 'filters.amenity.parking.name',
    defaultMessage: 'Parking'
  }
});
export var levelMessages = defineMessages({
  open: {
    id: 'filters.level.open',
    defaultMessage: 'Open'
  },
  beginner: {
    id: 'filters.level.beginner',
    defaultMessage: 'Beginner'
  },
  advanced: {
    id: 'filters.level.advanced',
    defaultMessage: 'Advanced'
  }
});